import { escapeRegExp } from "./regex-utils";

/**
 * for HTML ID
 * @param id
 */
export function prefixHashToID(id: string) {
    if (id.charAt(0) !== "#") {
        id = "#" + id;
    }
    return id;
}

const entityMap: any = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    "\"": "&quot;",
    "'": "&#39;",
    "/": "&#x2F;",
    "`": "&#x60;",
    "=": "&#x3D;",
};

export function htmlSpecialChars(text: string) {
    return String(text).replace(/[&<>"'`=\\/]/g, (s) => (entityMap[s] as string));
}

export function htmlSpecialCharsLax(text: any) {
    if (typeof text !== "string") {
        text = String(text);
    }
    return htmlSpecialChars(text);
}

/**
 * @see https://www.w3resource.com/javascript-exercises/javascript-string-exercise-27.php
 * @param text
 */
export function string2hex(text: string) {
    const array = [];
    for (let n = 0, l = text.length; n < l; n++) {
        const hexString = Number(text.charCodeAt(n)).toString(16);
        array.push(hexString);
    }
    return array.join("");
}

export function stripAllSubstring(text: string, substr: string) {
    return text.split(substr).join("");
}

/**
 * Makes the first letter of a string to Uppercase
 * @param input
 */
export function ucFirst(input: string) {
    return input.charAt(0).toUpperCase() + input.slice(1);
}

/**
 * like PHP's strtr
 * the variant with 2 
 * 
 * @see https://www.php.net/manual/en/function.strtr.php
 */
export function strtr(text: string, replacePairs: { [key: string]: string }) {
    const keys = Object.keys(replacePairs);
    keys.forEach((key) => {
        text = text.replace(new RegExp(escapeRegExp(key), "g"), replacePairs[key]);
    });
    return text;
}
